// import { permissionService } from 'shared/services';
import TransactionLog from '../containers/TransactionLog/TransactionLog.container';
import TransactionDetail from '../containers/TransactionDetail/TransactionDetail.container';
import goldRoute from '.';

// const { checkPermission } = permissionService;

const GoldNavigation = () => [
  ...[{ path: goldRoute.TRANSACTION_LOG, component: TransactionLog }],
  ...[{ path: goldRoute.TRANSACTION_DETAIL, component: TransactionDetail }],
];

export default GoldNavigation;
